import React, { useEffect } from "react";
import styles from "../styles/Home.module.css";
import { Link, useNavigate } from "react-router-dom";
import { BASE_URL } from "../Config";
import { useAuth } from "../providers/AuthProvider";

function Home() {
  const navigate = useNavigate();
  const handleGoogleLogin = async (e) => {
    // google login endpoint
    window.open(
      `${BASE_URL}/accounts/google/login/`
    );
    return;
  };
  const handlRobloxLogin = async (e) => {
    // google login endpoint
    window.open(
      `${BASE_URL}/accounts/roblox/login/`
    );
    return;
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const loginData = {
      username: "test",
      password: "cacho1234",
    };

    try {
      const response = await fetch(
        `${BASE_URL}/auth/token/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(loginData),
        }
      );

      if (response.ok) {
        const data = await response.json();
        const { access } = data;

        localStorage.setItem("jwtToken", access);
        console.log("Logged in successfully");

        onJWTLogin();
      } else {
        const errorData = await response.json();
      }
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const onJWTLogin = () => {
    navigate("/characters");
  };

  // navigate to characters if we are already signed in
  const { isAuthenticated } = useAuth();
  useEffect(()=>{
      console.log(isAuthenticated)
      if(isAuthenticated){
        navigate('/characters')
      }
  })

  return (
    <div className={styles.container}>
      <div className={styles.signInContent}>
        <div className={styles.gradient}></div>

        <div className={styles.login}>
          <h2>Sign In</h2>
          <p>
            Need to create an account? <Link>Sign Up</Link>
          </p>
          <button className={styles.button} onClick={handleLogin}>
            Developer
          </button>
          <button className={styles.button} onClick={handleGoogleLogin}>
            Google
          </button>
          <button className={styles.button} onClick={handlRobloxLogin}>
            Roblox
          </button>
        </div>
      </div>
    </div>
  );
}

export default Home;
